import { useState } from 'react'

import { type IRole } from '@/app/types/authType'
import { onToasting } from '@/app/utils'
import { BlurApp } from '@/shared'
import { useDragAndDrop } from '@App/hooks'
import { type ISwapSequencs, EToastings } from '@App/types/common'
import {
    type TMainCategoryData,
    type IServiceDec,
    type IChildServiceDec,
    type ICategoryDto
} from '@App/types/servicesTypes'
import { OTHERS_CATEGORY_ID } from '@Config/config'

import { RemoveCategoryModal } from '../RemoveCategoryModal/RemoveCategoryModal'

import { AddSectionModal } from './AddSectionModal/AddSectionModal'
import style from './CategoriesList.module.scss'
import { CategoryItem } from './CategoryItem/CategoryItem'

interface IProps {
    categoriesList: IServiceDec[]
    adminRoles?: IRole[]
    onSwapServices: (dto: ISwapSequencs) => void
    onSwapCategories: (dto: ISwapSequencs) => void
    onGetSectionsRules: (id: string) => void
    onSetTranferSevice: (tranferSevice: IChildServiceDec | null) => void
    onRemoveCategory: (id: string, onSuccess: () => void) => void
    onEditCategory: (dto: ICategoryDto, onSuccess: () => void) => void
    onAddSection: (dto: ICategoryDto, onSuccess: () => void) => void
    onRemoveSection: (id: string, onSuccess: () => void) => void
    onEditSection: (dto: ICategoryDto, onSuccess: () => void) => void
}

export const CategoriesList = (props: IProps) => {
    const {
        categoriesList,
        // adminRoles,
        onSwapServices,
        onSwapCategories,
        onGetSectionsRules,
        onSetTranferSevice,
        onRemoveCategory,
        onEditCategory,
        onAddSection,
        onRemoveSection,
        onEditSection
    } = props

    const [chosen, setChosen] = useState<string | null>(null)

    const [removableCategory, setRemovableCategory] = useState<TMainCategoryData | null>(null)
    const [editableCategory, setEditableCategory] = useState<TMainCategoryData | null>(null)
    const [addSectionId, setAddSectionId] = useState<string | null>(null)

    const {
        currentItem,
        highlited,
        setHighlited,
        onDragStartHandler,
        onDragLeaveHandler,
        onDragEndHandler,
        onDragOverHandler
    } = useDragAndDrop()

    const onDropHandler = (e: any, item: IServiceDec) => {
        e.preventDefault()
        setHighlited(null)
        if (!chosen) {
            if (currentItem?.id === OTHERS_CATEGORY_ID || item.id === OTHERS_CATEGORY_ID) {
                onToasting({ type: EToastings.WARN, message: 'Нельзя перемещать раздел "Иные услуги"' })
                return
            }
            if (currentItem && currentItem.id !== item.id) {
                onSwapCategories({
                    srcId: currentItem.id,
                    destId: item.id
                })
            }
        }
    }

    return (
        <div className={style.container}>
            <BlurApp show={!!editableCategory} />
            {addSectionId && (
                <AddSectionModal
                    show={!!addSectionId}
                    parentId={addSectionId}
                    onAddSection={onAddSection}
                    onClose={() => setAddSectionId(null)}
                />
            )}
            {removableCategory && (
                <RemoveCategoryModal
                    removableCategory={removableCategory}
                    onClose={() => setRemovableCategory(null)}
                    onRemoveCategory={onRemoveCategory}
                />
            )}
            {categoriesList.map((category) => (
                <CategoryItem
                    key={category.id}
                    chosen={chosen}
                    item={category}
                    editableCategory={editableCategory}
                    // adminRoles={adminRoles}
                    onSwapServices={onSwapServices}
                    onSwapCategories={onSwapCategories}
                    onGetSectionsRules={onGetSectionsRules}
                    setChosen={setChosen}
                    setAddSectionId={setAddSectionId}
                    setEditableCategory={setEditableCategory}
                    setRemovableCategory={setRemovableCategory}
                    onSetTranferSevice={onSetTranferSevice}
                    onEditCategory={onEditCategory}
                    onAddSection={onAddSection}
                    onRemoveSection={onRemoveSection}
                    onEditSection={onEditSection}
                    onDragEndHandler={onDragEndHandler}
                    onDragLeaveHandler={onDragLeaveHandler}
                    onDragOverHandler={onDragOverHandler}
                    onDragStartHandler={onDragStartHandler}
                    onDropHandler={onDropHandler}
                    highlited={highlited}
                />
            ))}
        </div>
    )
}
